import { render, staticRenderFns } from "./ViewJob.vue?vue&type=template&id=5a2c0d98&scoped=true"
import script from "./ViewJob.vue?vue&type=script&lang=js"
export * from "./ViewJob.vue?vue&type=script&lang=js"
import style0 from "./ViewJob.vue?vue&type=style&index=0&id=5a2c0d98&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a2c0d98",
  null
  
)

export default component.exports